import { inject, Injectable } from '@angular/core';

import { NEVER, shareReplay } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import type { CandidatesChannel } from '@core/websocket-legacy';
import { AdminSocket, fromChannel } from '@core/websocket-legacy';

@Injectable({ providedIn: 'root' })
export abstract class CandidatesRealtimeHandler {
  private readonly adminSocket = inject(AdminSocket);
  private readonly candidatesChannel$ = this.adminSocket.ready$.pipe(
    switchMap(() =>
      this.adminSocket.subscribeToChannel(`candidates:${this.adminSocket.companyId}`),
    ),
    catchError(err => {
      console.error(err);
      return NEVER;
    }),
    shareReplay(),
  );

  public anonymized$ = this.getChannel('candidates-anonymized');
  public deanonymized$ = this.getChannel('candidates-deanonymized');
  public revealed$ = this.getChannel('candidates-revealed');
  public concealed$ = this.getChannel('candidates-concealed');

  private getChannel<T extends CandidatesChannel, K extends Parameters<T['on']>[0]>(name: K) {
    return this.candidatesChannel$.pipe(
      switchMap((channel: unknown) => fromChannel(<CandidatesChannel>channel, name)),
      map(event => ({ candidateId: event.candidate_ids[0] })),
    );
  }
}
